/**
 * EE2 display copy only. Keep raw API/DB diagnostics intact, and never apply
 * this to briefs, prompt templates, design-system names, or generated HTML.
 * Replace branding rather than collapsing failures into a generic message:
 * status details and uncertain-submission / duplicate-work warnings must survive.
 */
export function emailExpress2ErrorMessage(error: unknown, fallback = "Please try again."): string {
  let message: string;
  if (typeof error === "string") {
    message = error;
  } else if (error instanceof Error) {
    message = error.message;
  } else if (error && typeof error === "object") {
    // Some API errors carry nested JSON rather than a single message string.
    // Serialize the envelope so status, nested causes, and recovery warnings
    // remain visible; the same replacements cover every nested string.
    try {
      message = JSON.stringify(error);
    } catch {
      message = fallback;
    }
  } else {
    message = fallback;
  }
  return (message.trim() ? message : fallback)
    .replace(/magic[\s_-]*patterns[\s_-]*api[\s_-]*key/gi, "email design service API key")
    .replace(/https?:\/\/(?:[\w-]+\.)*magicpatterns\.[a-z]+[^\s"'<>\\)]*/gi, "email design service endpoint")
    .replace(/magic[\s_-]*patterns/gi, "Email design service");
}